import { get, post } from '../../../../api/index';

export const getOrderInformation = params => get(`/api/purchase/v1/checkout/course`, params); // 下单信息
export const placeOrder = params => post(`/api/purchase/v1/order/submitOrder`, params); // 去支付
export const bdxtQuery = params => post(`/api/purchase/v1/bdxtQuery`, params);  // 订单支付查询



